export enum BankAccountType {
  PRIVATE_ACCOUNT = 'private account',
  BUSINESS_ACCOUNT = 'business account'
}
